import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Story } from "@/components/site/Story";
import { Services } from "@/components/site/Services";
import { CatalogPreview } from "@/components/site/CatalogPreview";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Story />
      <Services />
      <CatalogPreview />
    </>
  );
}
